import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'csv-to-json',
  version: '1.0.0',
  properties: [
    {
      key: 'inputData',
      label: 'Input Data',
      type: 'text',
      required: false,
      default: '',
      placeholder: 'e.g., {{ $node.previousNode.data.csv }}',
      description: 'CSV data to convert to JSON. Leave empty to use data from previous node.',
      typeOptions: {
        rows: 4,
      },
    },
    {
      key: 'delimiter',
      label: 'Delimiter',
      type: 'string',
      default: ',',
      placeholder: ',',
      description: 'Character used to separate values',
    },
    {
      key: 'hasHeaders',
      label: 'Has Headers',
      type: 'boolean',
      default: true,
      description: 'First row contains column headers',
    },
    {
      key: 'trimValues',
      label: 'Trim Values',
      type: 'boolean',
      default: true,
      description: 'Remove leading and trailing whitespace from values',
    },
    {
      key: 'skipEmptyLines',
      label: 'Skip Empty Lines',
      type: 'boolean',
      default: true,
      description: 'Skip empty lines in the CSV data',
    },
  ],
};

export default schema;
